import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Modal from "../../../app/universalComponents/Modal";
import Alert from "../../../app/universalComponents/Alert";
import Button from "../../../app/universalComponents/Button";
import { publishEvent, deleteEvent } from "../../create-edit/createEditApi";
import { getGuestList, copyEventLink } from "../dashboardApi"
// import { deleteEvent } from "../../create-edit/createEditApi";

export default function EventActions({ id, status, slug }) {
    const navigate = useNavigate();
    const [pendingAction, setPendingAction] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [copied, setCopied] = useState(false);

    async function handleCopyEventLink() {
        try {
            await copyEventLink(slug);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (error) {
            console.error("Failed to copy event link:", error);
        }
    }

    const confirmation = {
        delete: {
            label: "Delete Event",
            text: "Are you sure you want to delete this event? This action cannot be undone.",
            button: "Delete Event",
            tone: "red",
        },
        publish: {
            label: "Send Event for Review",
            text: "Are you sure you want to send this event for review? Approval usually takes about 24 hours.",
            button: "Send for Review",
            tone: "green",
        },
    }[pendingAction];

    function closeConfirmation() {
        if (isSubmitting) return;

        setPendingAction(null);
    }

    async function confirmAction() {
        if (!pendingAction || isSubmitting) return;

        setIsSubmitting(true);

        try {
            if (pendingAction === "delete") {
                await deleteEvent(id);
            }

            if (pendingAction === "publish") {
                await publishEvent(id);
            }

            window.location.reload();
        } catch (error) {
            alert("Something went wrong. Try again later.");
            setIsSubmitting(false);
        }
    }

    if (status === "draft") {
        return (
            <>
                <Alert tone="positive" className="w-full space-y-2 rounded-sm p-4 md:w-96">
                    <div>
                        <h2 className="text-base font-semibold">
                            Ready to publish this event?
                        </h2>

                        <p className="text-sm text-gray-600">
                            Events need to be reviewed before publishing. It usually takes under 12 hours.
                        </p>
                    </div>

                    <div className="flex gap-2">
                        <Button type="button" variant="secondary" tone="red" className="flex-1 text-sm" onClick={() => setPendingAction("delete")}>
                            Delete Event
                        </Button>

                        <Button type="button" tone="green" className="flex-1 text-sm" onClick={() => setPendingAction("publish")}>
                            Send for Review
                        </Button>
                    </div>
                </Alert>

                <Modal isOpen={pendingAction !== null} onClose={closeConfirmation} label={confirmation?.label} className="w-full max-w-sm p-4">
                    <p className="text-sm text-gray-600">
                        {confirmation?.text}
                    </p>

                    <div className="mt-4 flex gap-2 text-sm">
                        <Button type="button" variant="secondary" onClick={closeConfirmation} disabled={isSubmitting} className="flex-1">
                            Cancel
                        </Button>

                        <Button type="button" onClick={confirmAction} disabled={isSubmitting} className="flex-1">
                            Confirm
                        </Button>
                    </div>
                </Modal>
            </>
        );
    }

    if (status === "pending_approval") {
        return (
            <Alert tone="neutral" className="w-full rounded-sm border p-4 md:w-96">
                <h2 className="text-base font-semibold">
                    Your event is being reviewed
                </h2>

                <p className="text-sm text-gray-600">
                    The event has been submitted and is currently being reviewed. It won't be available to ticket buyers until it's approved.
                </p>
            </Alert>
        );
    }

    if (["cancelled"].includes(status)) {
        return null;
    }

    return (
        <section className="space-y-2">
            <div className="flex w-full gap-2">
                <Button variant="secondary" onClick={() => navigate("/scanner")} className="flex-1">
                    Scanner
                </Button>

                <Button variant="secondary" onClick={() => getGuestList(id)} className="flex-1">
                    Guestlist
                </Button>
            </div>

            <Button type="button" onClick={handleCopyEventLink} className="w-full">
                {copied ? "Link Copied" : "Copy Event Link"}
            </Button>
        </section>
    );
}